// extracted by mini-css-extract-plugin
export var actionButton = "_dz-0";
export var fileInput = "_dz-2";
export var paperclip = "_dz-1";